export default __webpack_public_path__ + "static/media/RealNews.9a1fa2e2.PNG";